export const defaultWelcomeNotificationFormat = `Hi #[patient_first_name],

Welcome to #[clinic_name]. You will be receiving notifications from this address for future updates.

Regards,
#[clinic_name]
#[clinic_address]
#[clinic_phone_number]`;
